import { useEffect, useState } from "react";
import { Layout } from "../components/Layout";
import { api } from "../lib/api";
import { VerdictPill } from "../components/VerdictBadge";
import { cn } from "../lib/utils";

const ACTION_COLOR = {
  alert_ucm: "text-freddy-red",
  bid: "text-verdict-buyText",
  won: "text-verdict-strongText",
  lost: "text-slate-600",
  passed: "text-slate-500",
  overridden: "text-verdict-passText",
  acquired: "text-verdict-strongText",
};

export default function CorporateAuditLog() {
  const [decisions, setDecisions] = useState([]);
  useEffect(() => { api.get("/decisions?limit=300").then((r) => setDecisions(r.data)); }, []);

  return (
    <Layout variant="corporate">
      <div className="mb-6">
        <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">Corporate</div>
        <h1 className="text-3xl font-bold text-navy">Audit log</h1>
        <p className="text-sm text-slate-500 mt-1 font-medium">Every decision, every override — with 60-day reconciliation.</p>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr className="text-[10px] uppercase tracking-wider text-slate-600">
              <th className="text-left px-4 py-3 font-bold">Time</th>
              <th className="text-left px-4 py-3 font-bold">User</th>
              <th className="text-left px-4 py-3 font-bold">Action</th>
              <th className="text-left px-4 py-3 font-bold">VIN</th>
              <th className="text-center px-4 py-3 font-bold">Score</th>
              <th className="text-center px-4 py-3 font-bold">Verdict</th>
              <th className="text-right px-4 py-3 font-bold">Max bid</th>
              <th className="text-right px-4 py-3 font-bold">Actual</th>
              <th className="text-left px-4 py-3 font-bold">Outcome</th>
              <th className="text-left px-4 py-3 font-bold">Override note</th>
            </tr>
          </thead>
          <tbody>
            {decisions.map((d) => (
              <tr key={d.decision_id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3 text-xs text-slate-500 tabular">{new Date(d.created_at).toLocaleString()}</td>
                <td className="px-4 py-3 text-xs font-semibold text-navy">{d.user_name}</td>
                <td className={cn("px-4 py-3 text-xs uppercase tracking-wider font-bold", ACTION_COLOR[d.action] || "text-slate-600")}>
                  {d.action.replace("_", " ")}
                </td>
                <td className="px-4 py-3 text-xs font-mono text-slate-600">{d.vin}</td>
                <td className="px-4 py-3 text-center tabular font-bold">{d.score_at_decision ?? "—"}</td>
                <td className="px-4 py-3 text-center">{d.verdict_at_decision ? <VerdictPill verdict={d.verdict_at_decision} /> : "—"}</td>
                <td className="px-4 py-3 text-right tabular">{d.max_bid ? `$${d.max_bid.toLocaleString()}` : "—"}</td>
                <td className="px-4 py-3 text-right tabular font-semibold">{d.actual_price ? `$${d.actual_price.toLocaleString()}` : "—"}</td>
                <td className="px-4 py-3 text-xs uppercase tracking-wider text-slate-600 font-semibold">{d.outcome || "—"}</td>
                <td className="px-4 py-3 text-xs text-slate-600 max-w-xs truncate">{d.override_justification || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
